import { Amplify } from 'aws-amplify';

const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  loginWith: {
    email: true,
  },
  signUpVerificationMethod: 'code',
  userAttributes: {
    email: {
      required: true,
    },
  },
  passwordFormat: {
    minLength: 8,
    requireLowercase: true,
    requireUppercase: true,
    requireNumbers: true,
    requireSpecialCharacters: true,
  },
};

// Only add identityPoolId if configured
if (process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID) {
  cognitoConfig.identityPoolId = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID;
}

const amplifyConfig = {
  Auth: {
    Cognito: cognitoConfig,
  },
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
